import React from "react";
import "./styles.css";

export const Title = ({ children }) => {
  return <span className="title">{children}</span>;
};
